import {Message} from "element-ui";
// import {Toast} from "vant";

export default {
    methods: {
        dispose({res}) {
            Message({
                message: res.msg,
                type: res.code === 1 ? 'success' : 'error',
                duration: 3 * 1000
            })
        },
        resDispose({res, successMag, errorMag, success, error}) {
            if (res.code === -1) {
                Message({
                    message: errorMag ?? res.msg,
                    type: 'error',
                    duration: 3 * 1000
                });
                if (typeof error === "function") {
                    error()
                }
            } else if (res.code === 1) {
                Message({
                    message: successMag ?? res.msg,
                    type: 'success',
                    duration: 3 * 1000
                });
                if (typeof success === "function") {
                    success()
                }
            }
        }, resDisposeWithoutSuccessMsg({res, successMag, errorMag, success, error}) {
            if (res.code === -1) {
                Message({
                    message: errorMag ?? res.msg,
                    type: 'error',
                    duration: 3 * 1000
                });
                if (typeof error === "function") {
                    error()
                }
            } else if (res.code === 1) {
                if (successMag){
                    Message({
                        message: successMag,
                        type: 'success',
                        duration: 3 * 1000
                    });
                }
                if (typeof success === "function") {
                    success()
                }
            }
        },getDataResDispose({res, errorMag, success, error}) {
            if (res.code === -1) {
                Message({
                    message: errorMag ?? res.msg,
                    type: 'error',
                    duration: 3 * 1000
                });
                if (typeof error === "function") {
                    error()
                }
            } else if (res.code === 1) {
                if (typeof success === "function") {
                    success()
                }
            }
        },
        resEditNoFetchDialog({res, form = 'params'}) {
            this.dispose({res});
            if (res.code === 1) {
                this.$refs[form].resetFields();
                this.noDialog();
            } else {
                Message({
                    message: res.msg,
                    type: 'error',
                    duration: 3000
                });
            }
        },
        resEditNoDialog({res, form = 'params'}) {
            this.dispose({res});
            if (res.code === 1) {
                this.$refs[form].resetFields();
                this.fetchNoDialog();
            }else {
                Message({
                    message: res.msg,
                    type: 'error',
                    duration: 3000
                });
            }
        },
        resNoDialog({res}) {
            this.dispose({res});
            if (res.code === 1) {
                this.fetchNoDialog();
            }else {
                Message({
                    message: res.msg,
                    type: 'error',
                    duration: 3000
                });
            }
        },
        resFetch({res}) {
            this.dispose({res});
            this.fetchData();
        }
    },
}
